/* WattWheelz V61.2 — PDP self-serve CRO */
(function(){
  function all(root,sel){return Array.prototype.slice.call(root.querySelectorAll(sel));}
  function hasText(el,needle){return el&&((el.textContent||'').toLowerCase().indexOf(needle.toLowerCase())>-1);}
  function init(){
    var root=document.querySelector('[data-product-root]');
    if(!root||root.dataset.wwSelfServe==='true') return;
    root.dataset.wwSelfServe='true';

    /* One optional pre-purchase support moment, kept subordinate to Add to Cart. */
    var support=root.querySelector('.ww-pdp-support');
    if(support){
      var oldActions=support.querySelector('.ww-pdp-support__actions');
      var call=oldActions&&oldActions.querySelector('a[href^="tel:"]');
      var email=oldActions&&oldActions.querySelector('a[href^="mailto:"]');
      var callHref=call?call.getAttribute('href'):'tel:+18885987034';
      var emailHref=email?email.getAttribute('href'):'mailto:support@wattwheelz.com';
      support.innerHTML='<div class="ww-pdp-support__copy"><span class="ww-eyebrow">Questions before ordering?</span><strong>E-bike specialists are available if you want a second opinion.</strong></div><div class="ww-pdp-support__actions"><a href="'+callHref+'">Call us</a><a href="'+emailHref+'">Email us</a></div>';
    }

    var disclosure=root.querySelector('.ww-reassurance-disclosure');
    if(disclosure){
      var summary=disclosure.querySelector('summary');
      if(summary) summary.innerHTML='Shipping, financing, warranty &amp; purchase details <span>View details</span>';
      var reassuranceItems=all(disclosure,'.ww-reassurance__item');
      if(reassuranceItems[3]){
        var t=reassuranceItems[3].querySelector('strong');
        var b=reassuranceItems[3].querySelector('small');
        if(t)t.textContent='Authorized dealer purchase';
        if(b)b.textContent='Genuine products with manufacturer-backed warranty coverage.';
      }
    }

    var intro=root.querySelector('.ww-details-intro > p');
    if(intro) intro.textContent='Explore key specifications, fit guidance, delivery information, warranty coverage and ownership details for this model.';

    var checklist=root.querySelector('.ww-detail-checklist');
    if(checklist){
      var eyebrow=checklist.querySelector('.ww-eyebrow');
      var heading=checklist.querySelector('h3');
      if(eyebrow) eyebrow.textContent='Before you order';
      if(heading) heading.textContent='Check the details that matter for your ride';
      all(checklist,'li').forEach(function(li){
        if(hasText(li,'purchase protection')) li.innerHTML='<strong>Purchase protection:</strong> Manufacturer warranty coverage applies under the published terms, and returns follow the current WattWheelz refund policy.';
      });
      var helpLink=checklist.querySelector('a');
      if(helpLink) helpLink.remove();
    }

    var fit=root.querySelector('[data-panel="fit"]');
    if(fit){
      all(fit,'li').forEach(function(li){if(hasText(li,'our team can help'))li.remove();});
    }

    var warranty=root.querySelector('[data-panel="warranty"]');
    if(warranty){
      var warrantyCols=all(warranty,'.ww-detail-two-col > div');
      if(warrantyCols[0]){
        var paras=all(warrantyCols[0],'p');
        if(paras[1]) paras[1].textContent='Warranty claims follow the manufacturer’s published process, eligibility rules and documentation requirements.';
        if(!warrantyCols[0].querySelector('.ww-selfserve-warranty-help')){
          var p=document.createElement('p');
          p.className='ww-selfserve-warranty-help';
          p.innerHTML='Need help with a warranty issue or an existing order? <a href="/pages/contact">Contact WattWheelz Support</a>.';
          warrantyCols[0].appendChild(p);
        }
      }
      var policy=warranty.querySelector('.ww-policy-callout');
      if(policy){
        all(policy,'p').forEach(function(p){
          if(hasText(p,'ask us before ordering')){
            var refundLink=p.querySelector('a');
            if(refundLink){p.innerHTML='';p.appendChild(refundLink);}
          }
        });
      }
    }

    var setup=root.querySelector('[data-panel="setup"]');
    if(setup){
      all(setup,'p').forEach(function(p){if(hasText(p,'our team can walk you through it'))p.remove();});
    }

    var faq=root.querySelector('[data-panel="faq"]');
    if(faq){
      all(faq,'details').forEach(function(d){var s=d.querySelector('summary');if(hasText(s,'need help choosing the right configuration'))d.remove();});
    }

    /* Carbon 1 Pro: preserve decision content, remove repeated service dependency framing. */
    if(root.getAttribute('data-product-handle')==='carbon-pro-1'){
      var carbon=root.querySelector('.ww-carbon-bof');
      if(carbon){
        all(carbon,'.ww-carbon-bof__section').forEach(function(section){
          var h=section.querySelector('h2');
          if(hasText(h,'manufacturer rider-height ranges')){
            var hp=section.querySelector('.ww-carbon-bof__head p');
            if(hp) hp.textContent='Use the published rider-height ranges below as your starting point, especially if you sit between two sizes.';
            all(section,'.ww-carbon-bof__actions').forEach(function(a){a.remove();});
          }
        });
        var dealer=carbon.querySelector('#why-wattwheelz');
        if(dealer){
          var dp=dealer.querySelector('.ww-carbon-bof__head p');
          if(dp) dp.textContent='At the same product price, the dealer decision comes down to authorized purchase protection, package value and clear ownership information.';
          all(dealer,'.ww-carbon-dealer-grid > div').forEach(function(card){
            var strong=card.querySelector('strong'), p=card.querySelector('p');
            if(hasText(strong,'expert fit help')){strong.textContent='Published Fit Guidance';if(p)p.textContent='Manufacturer rider-height ranges are presented clearly before you order.';}
            else if(hasText(strong,'setup support')){strong.textContent='Clear Ownership Information';if(p)p.textContent='Review setup, app, charging and ownership details directly on the product page.';}
            else if(hasText(strong,'warranty help')){strong.textContent='Manufacturer-Backed Warranty';if(p)p.textContent='Coverage follows Urtopia’s published warranty terms.';}
          });
          all(dealer,'.ww-carbon-bof__actions').forEach(function(a){a.remove();});
        }
      }
      var curated=root.querySelector('.ww-carbon-curated-overview');
      if(curated){
        all(curated,'li').forEach(function(li){
          if(hasText(li,'ask our team to confirm')) li.innerHTML='<strong>Specification note:</strong> Manufacturer production specifications can change by model revision. Check the selected configuration and published specifications before ordering.';
        });
      }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
